/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

$(function () {
  // Accessibility
  var accessibility = function () {
    var targetNodes = $('.js-product-single-swatch');
    var MutationObserver= window.MutationObserver || window.WebKitMutationObserver;
    var myObserver = new MutationObserver(mutationHandler);
    var config = {
      attributes: false,
      characterData: false,
      childList: true,
      subtree: true
    };
    var addAltTag = function (element) {
      $(element).find('img').each(function () {
        var $this = $(this);

        if (!$this.attr('alt')) {
          $this.attr('alt', '');
        }
      });
    };

    targetNodes.each(function () {
      myObserver.observe(this, config);
    });

    function mutationHandler(mutationRecords) {
      mutationRecords.forEach(function (mutation) {
        if (typeof mutation.addedNodes == 'object') {
          addAltTag('.kiwi-sizing-modal');
        }
      });
    }

    // Remove PageFly paragraph checkboxes
    $('[data-pf-type="Paragraph4"]').find('input[type="checkbox"]').remove();

    // lantern.roeye.com
    function setLanternAlt() {
      $('img[src^="https://lantern.roeye.com/track.php"]').attr('alt', '');
    }

    // Initial run in case any are present
    setLanternAlt();

    // Observe the whole document for added images
    var lanternObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          $(mutation.addedNodes).each(function() {
            if (this.nodeType === 1) { // Element node
              if (this.tagName === 'IMG' && this.src && this.src.indexOf('https://lantern.roeye.com/track.php') === 0) {
                $(this).attr('alt', '');
              } else {
                // Check descendants
                $(this).find('img[src^="https://lantern.roeye.com/track.php"]').attr('alt', '');
              }
            }
          });
        }
      });
    });
    lanternObserver.observe(document.body, { childList: true, subtree: true });
  };
  accessibility();


  // Embed Video
  var embedVideo = function () {
    var $trigger = $('.js-embed-video__video-trigger');

    $trigger.on('click', function (event) {
      event.preventDefault();

      var $thisTrigger = $(this);
      var $wrapper = $thisTrigger.closest('.js-embed-video');
      var youtubeVideoId = $thisTrigger.data('youtube-video-id');
      var youtubeUrl = 'https://www.youtube.com/embed/' + youtubeVideoId + '?autoplay=1&rel=0';
      var $iframe = $wrapper.find('.js-embed-video__iframe');

      $thisTrigger.remove();
      $iframe.attr('src', youtubeUrl);
      $iframe.removeClass('is-hidden');
    });
  }
  embedVideo();


  // Site Nav
  var siteNav = function () {
    var $window = $(window);
    var $trigger = $('.js-site-nav__trigger');
    var $productNav = $('.js-product-nav');

    var setProductNavHeight = function () {
      $productNav.each(function () {
        var $this = $(this);

        $this.closest('.js-expando__content').show();

        $this.css({
          'height': $window.innerHeight() - ($this.offset().top - $window.scrollTop()),
        });

        $this.closest('.js-expando__content').hide();
      });
    };

    $trigger.on('click', function () {
      var $body = $('body');

      if (!$body.hasClass('product-nav-is-open')) {
        setProductNavHeight();
      }

      $body.toggleClass('product-nav-is-open');
    });

    enquire.register('screen and (max-width: 767px)', {
      unmatch: function () {
        $('body').removeClass('product-nav-is-open');
      }
    });

    $window.on('resize', function () {
      setProductNavHeight();
    });
  }
  siteNav();


  // View Selector
  $('.js-view-selector').on('change', function () {
    var url = $(this).val();

	if (url) {
	    window.location = url;
	}

	return false;
  });
});
